import { render, staticRenderFns } from "./FlexLeaderboard.vue?vue&type=template&id=08c12ef0&scoped=true"
import script from "./FlexLeaderboard.vue?vue&type=script&setup=true&lang=js"
export * from "./FlexLeaderboard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FlexLeaderboard.vue?vue&type=style&index=0&id=08c12ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c12ef0",
  null
  
)

export default component.exports